import {FilterType} from "@domain/enums/FilterType";
import {FilterMapper} from "@app/routing/mappers/FilterMapper";
import {areasAll} from "@studyportals/static-domain-data/areas/areas";
import {areaGetPath} from "@studyportals/static-domain-data/areas/area-get-path";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class AreaFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.AREA;
	public isMultiSelect = true;
	private static instance: AreaFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [];

	public static getInstance(): AreaFilterMapper {
		if (!AreaFilterMapper.instance) {
			AreaFilterMapper.instance = new AreaFilterMapper();
		}
		return AreaFilterMapper.instance;
	}

	private constructor() {
		super();

		const typedAreas = areasAll as unknown as { id: number | string; name: string }[];

		for (const area of typedAreas) {
			const virtualPath = areaGetPath(area.id.toString()).split('/')[1];

			if (virtualPath) {
				this.values.push({
					id: area.id.toString(),
					virtualPath,
					name: area.name
				});
			}
		}
	}
}
